@if (control) {
  <mat-form-field
    appearance="outline"
    class="ui-form-field-v2"
    [subscriptSizing]="description || showClearButton ? 'dynamic' : 'fixed'"
  >
    @if (label) {
      <mat-label>{{ label }}</mat-label>
    }
    @if (prefixIcon) {
      <mat-icon matPrefix class="ui-form-field__icon">{{ prefixIcon }}</mat-icon>
    }
    @if (prependPlusSingForPositives && control.value > 0) {
      <span matTextPrefix class="text-input-plus-sign">+</span>
    }
    <input
      #input
      matInput
      [formControl]="control"
      [errorStateMatcher]="errorStateMatcher"
      [placeholder]="placeholder"
      [attr.aria-label]="ariaLabel || null"
      [required]="required"
      [tabindex]="tabIndex"
      [type]="type"
      [attr.min]="type === 'number' ? min : null"
      [attr.max]="type === 'number' ? max : null"
      (keydown)="keyDown($event)"
      (paste)="onPaste($event)"
      (input)="formatInput()"
    />
    @if (showErrorIcon) {
      <span matIconSuffix class="ui-form-field__status-icon" aria-hidden="true">
        <mat-icon class="ui-form-field__icon">error_outline</mat-icon>
      </span>
    } @else if (suffixIcon) {
      <span matIconSuffix class="ui-form-field__status-icon" aria-hidden="true">
        <mat-icon class="ui-form-field__icon">{{ suffixIcon }}</mat-icon>
      </span>
    } @else if (showClearButton && type !== 'file' && hasValue && control.enabled) {
      <button
        type="button"
        mat-icon-button
        matIconSuffix
        class="ui-form-field__icon-button"
        [attr.aria-label]="'clear' | translate"
        (click)="clearInput($event)"
      >
        <mat-icon class="ui-form-field__icon">highlight_off</mat-icon>
      </button>
    } @else if (showClearButton && type !== 'file') {
      <span matIconSuffix class="ui-form-field__suffix-spacer" aria-hidden="true"></span>
    }
    @if (description) {
      <mat-hint>{{ description }}</mat-hint>
    }
    @let errorText = control.errors | joinErrorMessages: messages;
    <mat-error [attr.title]="errorText">{{ errorText }}</mat-error>
  </mat-form-field>
}
